






import Vue from 'vue'
import InquiryContainer from '@/containers/Inquiry/Inquiry'

export default Vue.extend({
  components: {
    InquiryContainer
  },
  middleware: ['retentionAuth'],
  computed: {
    categoryId(): number | null {
      const categoryId = this.$route.query['categoryId']
      return typeof categoryId === 'string' ? parseInt(categoryId, 10) : null
    }
  }
})
